import React, { useEffect, useState, useLayoutEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setCoupon } from "../../../../features/CouponSlice";

import moment from "moment";

import img_icoTicket from "../../../../assets/img/ci/ico-coupon/ico-ticket.svg";
import img_badgeType1 from "../../../../assets/img/ci/ico-coupon/badge-type-1.svg";
import img_badgeType2 from "../../../../assets/img/ci/ico-coupon/badge-type-2.svg";
import img_badgeType3 from "../../../../assets/img/ci/ico-coupon/badge-type-3.svg";
import img_badgeType4 from "../../../../assets/img/ci/ico-coupon/badge-type-4.svg";

const BadgeCoupon = ({ couponType }) => {
  let badgeImg = "";

  switch (couponType) {
    case 1:
    case "1":
      badgeImg = <img src={img_badgeType1} />;
      break;

    case 2:
    case "2":
      badgeImg = <img src={img_badgeType2} />;
      break;

    case 3:
    case "3":
      badgeImg = <img src={img_badgeType3} />;
      break;

    case 4:
    case "4":
      badgeImg = <img src={img_badgeType4} />;
      break;

    default:
      break;
  }

  return <>{badgeImg}</>;
};

const CardCoupon = (props) => {
  const dispatch = useDispatch(); // ไว้อัพเดต state กลาง

  const setDataCoupon = (newData) => {
    const tmpObj = { id: newData.id, data: newData, redeem: {} };
    dispatch(setCoupon(tmpObj)); // setStateRedux ส่งค่าเก็บเข้า state กลาง
  };

  /* Handle goto coupon detail page */
  const navigate = useNavigate();

  const handleGotoCouponDetail = (e) => {
    e.preventDefault();
    // console.log("handleGotoCouponDetail >>", props.dataCoupon);

    setDataCoupon(props.dataCoupon);

    navigate("/coupon/detail");
  };
  /* End Handle goto coupon detail page */

  // useEffect(() => {
  //   // console.log("props", props);
  // }, []);

  /* Check image exists */
  const [imageExists, setImageExists] = useState(false);

  useEffect(() => {
    // console.log("props", props);

    const img = new Image();
    img.src = props.dataCoupon.thumbnailImg;

    img.onload = () => {
      setImageExists(true);
    };

    // img.onerror = () => {
    //   setImageExists(false);
    // };
  }, [props.dataCoupon.thumbnailImg]);
  /* End Check image exists */

  const [height, setHeight] = useState(0);
  const eleRef = useRef(null);

  useEffect(() => {
    // console.log(props.index, height, props.curHeight);
    props.setNewHeight(props.index, height);
  }, [height]);

  useLayoutEffect(() => {
    const handleResize = () => {
      setHeight(eleRef.current.offsetHeight);
    };
    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <article
      ref={eleRef}
      data-id={props.dataCoupon.id}
      data-type={props.dataCoupon.couponType ?? props.dataCoupon.type}
      data-startdate={props.dataCoupon.startDate}
      data-enddate={props.dataCoupon.endDate}
      onClick={handleGotoCouponDetail}
    >
      <div className="bPic">
        <span className="bBadge">
          <BadgeCoupon
            couponType={props.dataCoupon.couponType ?? props.dataCoupon.type}
          />
        </span>
        {imageExists ? (
          <img src={props.dataCoupon.thumbnailImg} />
        ) : (
          <img src={img_icoTicket} />
        )}
      </div>
      <div className="bDetails">
        <div className="bValue">
          <p>{props.dataCoupon.name}</p>
          <div className="bDate">
            วันนี้ -{" "}
            {/* {moment(props.dataCoupon.endDate).format("DD/MM/YY")} */}
            {moment(props.dataCoupon.endDate).format("DD/MM/") +
              (parseInt(moment(props.dataCoupon.endDate).format("YYYY")) + 543)
                .toString()
                .slice(-2)}
          </div>
        </div>
        <div className="bPoint">
          <div className="bBtn">
            {/* <a href="#" onClick={handleGotoCouponDetail}> */}
            {props.dataCoupon?.isPrivilegeUsedFull === false ? (
              <a href="#">
                {props.dataCoupon.point === 0
                  ? `ฟรี`
                  : `ใช้ ${parseInt(
                      props.dataCoupon.point
                    ).toLocaleString()} คะแนน`}
              </a>
            ) : (
              <a className="bUsedFull">สิทธิ์เต็มแล้ว</a>
            )}
          </div>
        </div>
      </div>
    </article>
  );
};

export default CardCoupon;
